import { render } from "./TransferListPage.vue?vue&type=template&id=d47720c6&scoped=true&ts=true"
import script from "./TransferListPage.vue?vue&type=script&lang=ts"
export * from "./TransferListPage.vue?vue&type=script&lang=ts"

import "./TransferListPage.vue?vue&type=style&index=0&id=d47720c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47720c6"]])

export default __exports__